import { Routes, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { CustomLayoutComponent } from "../layout/custom-layout/custom-layout.component";
import { InternationalActivitiesComponent } from "./international-activities.component";

const routes: Routes = [
    {
        path: 'international-activities/:linea',
        component: CustomLayoutComponent,
        children: [
            { path: '', component: InternationalActivitiesComponent },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class InternationalActivitiesRoutingModule { }
